import * as React from "react";
import {
  Card,
  CardMedia,
  CardContent,
  CardActions,
  Typography,
  Button,
} from "@mui/material";

const size = {
  small: "23%",
  medium: "48%",
  large: "98%",
};

export default function CorporateSponsors() {
  return (
    <div
      style={{
        display: "flex",
        width: "80%",
        margin: "20px auto 20px auto",
        flexWrap: "wrap",
      }}
    >
      {itemData.map((item) => (
        <Card sx={{ maxWidth: item.level, margin: "1%" }}>
          <CardMedia
            component="img"
            sx={{
              // height: "80%",
              width: "90%",
              margin: "5% 5% 5% 5%",
            }}
            image={item.img}
            alt={item.title}
          />
          <CardContent>
            <Typography gutterBottom variant="h5" component="div">
              {item.title}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {item.description}
            </Typography>
          </CardContent>
          <CardActions>
            <Button
              color="success"
              href={item.link}
              target="_blank"
              size="small"
            >
              Learn More
            </Button>
          </CardActions>
        </Card>
      ))}
    </div>
  );
}

const itemData = [
  {
    img: "/vegan-proteins.png",
    title: "Vegan Proteins",
    description: "We coach you to build a strong, lean body on plants!",
    link: "https://www.veganproteins.com/",
    level: size.large,
  },
  // {
  //   img: "/PlantFusion_logo_color.png",
  //   title: "PlantFusion",
  //   description:
  //     "At PlantFusion we are obsessed with offering authentic, 100% plant-based, nutrient dense products that delight the senses. This fusion of unique ingredients and flavors provides complete nourishment.",
  //   // "Tasty, delicious foods that are better for our bodies, better for our taste buds and farmer buds alike. Better for degraded lands, our eco-systems and naturally... better for cows.",
  //   link: "https://plantfusion.com/",
  //   level: size.large,
  // },
  {
    img: "/Ultima_Wordmark_White-w.png",
    title: "Ultima Replenisher",
    description:
      "Your daily zero sugar hydrating electrolyte drink, water enhancer and all around refresher!",
    link: "https://www.ultimareplenisher.com/",
    level: size.large,
  },
  {
    img: "/PB2.png_translucent_bg.png",
    title: "PB2",
    description: "Peanut Butter Re-Imagined",
    link: "https://www.pb2foods.com/",
    level: size.large,
  },
  // {
  //   img: "/hodo_logo.png",
  //   title: "HODO",
  //   description:
  //     "We only make plant-based foods you’ll love, whether you’re a meat-eater, a vegetarian, or anything in between. ",
  //   link: "https://www.hodofoods.com/",
  //   level: size.medium,
  // },
  // {
  //   img: "/unisoy_logo_plantbuilt.png",
  //   title: "Unisoy",
  //   description:
  //     "High protein, zero cholesterol plant-based snacking in six delicious flavors!",
  //   link: "https://unisoyjerky.com/",
  //   level: size.medium,
  // },
  // {
  //   img: "/Healthy Truth Logo White.png",
  //   title: "Healthy Truth",
  //   description: "Empowering The World To Better Health",
  //   link: "https://www.healthytruth.com/",
  //   level: size.medium,
  // },
];
